import Link from 'next/link';
import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
export const AgreementPage = () => {
  return <>
      <PageSeo title="Персональные данные" description="Соглашение об обработке персональных данных. Enlerno – деловой английский для работы." noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Согласие на обработку персональных данных</h1>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <p>
            Настоящий документ регулирует обработку персональных данных Индивидуальным предпринимателем Сладких Анной
            Святославовной (ИНН 745312661384, ОГРНИП 323745600057252) (далее – Оператор) в двух контурах: на сайте
            https://enlerno.ru (включая поддомены, за исключением случаев, отдельно указанных ниже) и на платформе
            https://study.enlerno.ru. Общие принципы обработки персональных данных Оператором раскрыты в{' '}
            <Link href="/privacy-policy" className="underline">
              Политике в отношении обработки персональных данных
            </Link>
            .
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">Раздел 1. Сайт https://enlerno.ru (формы и аналитика)</h2>

          <p>
            Пользователь, заполняя форму обратной связи на интернет-сайтах www.enlerno.ru (включая поддомены) (далее
            Сайт Проекта), принимает настоящее Согласие на обработку персональных данных (далее – Согласие). Действуя
            свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, Пользователь дает свое
            согласие Индивидуальному предпринимателю Сладких Анне Святославовне (ИНН 745312661384, ОГРНИП
            323745600057252) на обработку своих персональных данных со следующими условиями:
          </p>

          <ul className="list-inside list-decimal space-y-1">
            <li>
              Данное Согласие дается на обработку персональных данных, как без использования средств автоматизации, так
              и с их использованием.
            </li>

            <li>
              Согласие дается на обработку следующих персональных данных, не являющихся специальными или
              биометрическими: номер телефона и/или никнейм в мессенджере Telegram, указанные Пользователем в форме
              обратной связи; фамилия, имя и адрес электронной почты, указанные Пользователем при оформлении оплаты
              услуг; пользовательские данные (сведения о местоположении; тип и версия ОС; тип и версия Браузера; тип
              устройства и разрешение его экрана; источник, откуда пользователь пришел на сайт; язык ОС и Браузера;
              какие страницы открывает и на какие кнопки нажимает пользователь; ip-адрес).
            </li>

            <li>Персональные данные не являются общедоступными.</li>

            <li>
              Если Пользователь не достиг возраста 14 лет, согласие на обработку его персональных данных дается его
              родителем (законным представителем).
            </li>

            <li>
              Оператор использует для аналитики действий Пользователя сервисы Яндекс.Метрика и Google Analytics / Google
              Tag. Сведения об этом, включая трансграничную передачу персональных данных, приведены в{' '}
              <Link href="/privacy-policy" className="underline">
                Политике обработки персональных данных
              </Link>
              .
            </li>

            <li>
              Цель обработки персональных данных: обработка входящих запросов на получение обучающих материалов Сайтов
              Проекта; аналитика действий пользователя на веб-сайте и функционирование веб-сайта; проведение рассылки
              новостей.
            </li>

            <li>
              Основанием для обработки персональных данных является: ст. 24 Конституции Российской Федерации; ст.6
              Федерального закона №152-ФЗ «О персональных данных»; настоящее согласие на обработку персональных данных.
            </li>

            <li>
              Перечень действий, совершаемых с персональными данными, приведен в{' '}
              <Link href="/privacy-policy" className="underline">
                Политике обработки персональных данных
              </Link>
              .
            </li>

            <li>
              Персональные данные обрабатываются до отписки пользователя от рассылки (ссылка на отписку есть в каждом
              письме). Также обработка персональных данных может быть прекращена по запросу субъекта персональных
              данных.
            </li>

            <li>
              Согласие может быть отозвано субъектом персональных данных или его представителем путем направления
              заявления об отзыве согласия на обработку персональных данных на электронную почту:
              {process.env.NEXT_PUBLIC_EMAIL_URL ?? ''}
            </li>

            <li>
              В случае отзыва субъектом персональных данных или его представителем согласия на обработку персональных
              данных ИП Сладких А. С. вправе продолжить обработку персональных данных без согласия субъекта персональных
              данных при наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2
              статьи 11 Федерального закона №152-ФЗ «О персональных данных» от 27.07.2006 г.
            </li>

            <li>
              Настоящее согласие в части Сайта Проекта действует все время до момента прекращения обработки персональных
              данных, указанных в п.9 и п.10 данного раздела Согласия.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">Раздел 2. Платформа https://study.enlerno.ru</h2>

          <p>
            Пользователь, регистрируясь и/или используя платформу https://study.enlerno.ru (включая функционал личного
            кабинета, расписания и материалов для консультаций) (далее – Платформа), принимает настоящее Согласие в
            части обработки персональных данных на Платформе. Действуя свободно, своей волей и в своем интересе, а также
            подтверждая, что достиг возраста 18 лет и является дееспособным, Пользователь дает согласие Индивидуальному
            предпринимателю Сладких Анне Святославовне (ИНН 745312661384, ОГРНИП 323745600057252) на обработку
            персональных данных на следующих условиях:
          </p>

          <ul className="list-inside list-decimal space-y-1">
            <li>
              Согласие дается на обработку персональных данных как без использования средств автоматизации, так и с их
              использованием.
            </li>

            <li>
              Состав персональных данных, не являющихся специальными или биометрическими: фамилия, имя, отчество (при
              наличии); адрес электронной почты; номер телефона (при указании); данные учетной записи Платформы (логин и
              иные идентификаторы); сведения, связанные с организацией и проведением консультаций по английскому языку
              (в том числе сведения о расписании, посещаемости, выполненных заданиях и прогрессе в рамках Платформы);
              технические данные в объеме, обрабатываемом Платформой (включая IP-адрес, сведения о браузере и
              устройстве).
            </li>

            <li>Персональные данные не являются общедоступными.</li>

            <li>
              Цели обработки: предоставление доступа к Платформе; создание и сопровождение учетной записи; организация и
              проведение консультаций по английскому языку; планирование расписания; учет выполнения заданий и
              прогресса; связь с Пользователем; исполнение договора об оказании услуг на условиях публичной оферты
              https://enlerno.ru/public-offer
            </li>

            <li>
              Основание обработки: ст. 24 Конституции Российской Федерации; ст. 6 Федерального закона №152-ФЗ «О
              персональных данных»; настоящее согласие; договор с Пользователем (при его заключении).
            </li>

            <li>
              Поручение обработки третьему лицу. Оператор поручает обработку персональных данных Пользователя на
              Платформе ООО «ПрогрессМи» (сервис ProgressMe) на основании ч. 3 ст. 6 Федерального закона №152-ФЗ и п.
              5.12 Пользовательского соглашения ProgressMe (https://progressme.ru/legal/terms). Подробности о поручении
              обработки, включая сохранение за Оператором статуса оператора персональных данных, приведены в{' '}
              <Link href="/privacy-policy" className="underline">
                Политике обработки персональных данных
              </Link>
              .
            </li>

            <li>
              Перечень действий, совершаемых с персональными данными на Платформе, приведен в{' '}
              <Link href="/privacy-policy" className="underline">
                Политике обработки персональных данных
              </Link>
              .
            </li>

            <li>
              Срок обработки — в течение срока использования Платформы и исполнения договора об оказании услуг, а также
              в сроки, установленные законодательством РФ. Обработка может быть прекращена по запросу субъекта
              персональных данных, если иное не предусмотрено законодательством.
            </li>

            <li>
              Согласие может быть отозвано путем направления заявления на электронную почту Оператора:{' '}
              {process.env.NEXT_PUBLIC_EMAIL_URL ?? ''}. В случае отзыва Оператор вправе продолжить обработку при
              наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11
              Федерального закона №152-ФЗ «О персональных данных» от 27.07.2006 г.
            </li>

            <li>
              Настоящее согласие в части Платформы действует до прекращения обработки персональных данных, указанных в
              настоящем разделе.
            </li>
          </ul>
        </section>
      </Article>
    </>;
};
AgreementPage.Layout = MainLayout;